import initModel from './model'
import './detail.scss'
import changeImg from '../../../../../page-resource/lesson/img/play/change.png'
import changeBanImg from '../../../../../page-resource/lesson/img/play/change-ban.png'
const classNamePrefix = 'lesson-play-consult-detail'
const classNameModelPrefix = 'lesson-play-consult-model'

const render = store => {
  const { teacherList, showIndex } = store
  const item = teacherList[showIndex % teacherList.length]
  return `
    <div class="${classNamePrefix}">
      <div class="${classNamePrefix}-avatar">
        <img src="${item.avatar}?x-oss-process=image/resize,w_100" />
      </div>
      <div class="${classNamePrefix}-name">${item.name}</div>

      <div class="${classNamePrefix}-info">
        <p class="mr20">
          <span>${item.zx_num}</span>
          咨询人次
        </p>
        <p>
          <span>${item.experience_year}年</span>
          从业年限
        </p>
      </div>

      <div class="${classNamePrefix}-title" style="padding-top: 0">个人介绍</div>
      <div class="${classNamePrefix}-desc">${item.honor}</div>
      ${
        Object.keys(item.category).length
          ? `<div class="${classNamePrefix}-title">擅长领域</div>
        <div class="${classNamePrefix}-desc">
          ${Object.keys(item.category)
            .map(key => item.category[key])
            .join()}
        </div>`
          : ''
      }


      <div class="${classNamePrefix}-title">本次咨询  你将获得</div>
      <div class="${classNamePrefix}-desc">对你当前的困惑进行系统梳理；<br/>
      挖掘并分析困惑背后的深层原因；<br />
      结合咨询目标，探索未来成长方案；</div>

      <div class="${classNamePrefix}-title">特别提醒</div>
      <div class="${classNamePrefix}-desc">
      1.本服务为20分钟的语音咨询预沟通，旨在沟通需求，加深双方了解；如需正式的心理咨询，可在完成本次沟通后，新用户可<span>5折优惠预约该咨询师</span>。<br />
      2.下单后需主动与老师<span>协商咨询时间</span>。<br />
      3.与每名咨询师只有1次咨询预沟通机会。
      4.本预咨询为指定<span>课程限量专享补贴价，每位用户只有1次机会</span>。
      </div>
    </div>
  `
}
const renderTop = couponId => {
  return `
  <div class="${classNameModelPrefix}-agreement">
      <label class="${classNameModelPrefix}-label">
        <input type="checkbox" id="checkZixun">
        <div class="yxl-font ${classNameModelPrefix}-checkbox"></div>
      </label>
      同意
      <span class="${classNameModelPrefix}-treaty">《心理咨询预约协议》</span>
    </div>
    ${
      couponId
        ? `<div class="${classNameModelPrefix}-banner">即将恢复原价￥29.9 仅剩 1 名额</div>`
        : ''
    }
  `
}
export default store => {
  const changeBan = store.teacherList.length === 1
  const couponId = store.couponData && store.couponData.id
  const orderBtnPrice = couponId ? 9.9 : 29.9
  const model = initModel({
    html: () => render(store),
    topHtml: renderTop(couponId),
    changeBtn: {
      isBan: changeBan,
      img: changeBan ? changeBanImg : changeImg,
      label: '换一换',
      onclick: () => !changeBan && store.changeTeacher()
    },
    orderBtn: {
      label: `限时￥${orderBtnPrice} 立即预约`,
      onclick: () => store.createOrder()
    },
    onHide() {
      store.onDetailHide()
    },
    couponId
  })
  // model.show()

  return model
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/consult/detail.js